<template>
  <div class="xiaohui">
    <!-- 顶部标题栏 -->
    <div class="header">
      <div class="title">小慧</div>
    </div>

    <!-- 顶部横幅 -->
    <div class="banner">
      <img :src="imgs.logo" class="banner-logo" alt="人社logo" />
      <div class="banner-text">
        <div class="banner-line1">江苏省人力资源和社会保障厅</div>
        <div class="banner-line2">
          <span>网上办事服务大厅</span>
          <span class="banner-divider"></span>
          <span class="banner-assistant">智能助手</span>
        </div>
      </div>
    </div>

    <!-- 聊天区域 -->
    <div class="chat-area" ref="chatArea">
      <div v-for="(msg, idx) in messages" :key="idx" class="message-item" :class="{ 'user-msg': msg.isUser }">
        <img v-if="!msg.isUser" :src="imgs.avatar" class="avatar" alt="小慧头像" />
        <div class="bubble" :class="{ 'user-bubble': msg.isUser }">
          <div v-if="msg.isTip" class="tip-content">
            <div class="tip-title">换个问法试试吧，如果还不能回答我就需要更加努力学习了。</div>
            <div class="tip-sub">★您可能还关注与此相关的其他问题：</div>
            <div class="tip-action" @click="handleAction(msg)">转人工</div>
          </div>
          <div v-else>{{ msg.text }}</div>
        </div>
        <img v-if="msg.isUser" :src="imgs.userAvatar" class="avatar" alt="用户头像" />
      </div>
    </div>

    <!-- 底部区域 -->
    <div class="footer">
      <div class="location-bar">
        <span class="loc-label">当前：<span class="highlight">{{ currentRegion }}</span></span>
        <span class="switch-btn" @click="showRegionPicker = true">
          <svg viewBox="0 0 24 24" class="switch-icon">
            <path d="M19.5 12a7.5 7.5 0 0 1-13.4 4.6M4.5 12a7.5 7.5 0 0 1 13.4-4.6" fill="none" stroke="#2E8AF0" stroke-width="2.2" stroke-linecap="round"/>
            <path d="M18.5 3.5v4h-4M5.5 20.5v-4h4" fill="none" stroke="#2E8AF0" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          点击切换
        </span>
        <span class="suggest-btn" @click="showSuggestion = true">我给小慧提建议</span>
      </div>
      <div class="input-bar">
        <input class="input-field" v-model="inputValue" placeholder="请输入您的问题" @keyup.enter="sendMessage" />
        <button class="send-btn" @click="sendMessage">发送</button>
      </div>
      <div class="footer-info">
        <div class="footer-left">
          <img :src="imgs.badge" class="badge-img" alt="党政机关" />
          <img :src="imgs.findError" class="find-error-img" alt="政府网站找错" />
        </div>
        <div class="contact-info">
          <div class="contact-title">联系我们</div>
          <div>版权所有：江苏省人力资源和社会保障厅</div>
          <div>主办单位：江苏省人力资源和社会保障厅</div>
          <div>备案序号：苏ICP备10039190号-6</div>
          <div>政府网站标识码：3200000033</div>
          <div>苏公网安备：32010602010417</div>
        </div>
      </div>
    </div>

    <!-- 省市区选择弹窗 -->
    <div class="region-dialog" v-if="showRegionPicker">
      <div class="dialog-mask" @click="showRegionPicker = false"></div>
      <div class="region-panel">
        <div class="panel-header">
          <span class="panel-title">选择省市区</span>
          <span class="panel-close" @click="showRegionPicker = false">关闭</span>
        </div>
        <div class="region-list">
          <div class="region-item" v-for="(region, idx) in regions" :key="idx" :class="{ active: region === currentRegion }" @click="selectRegion(region)">
            {{ region }}
          </div>
        </div>
      </div>
    </div>

    <!-- 建议弹窗 -->
    <div class="suggestion-dialog" v-if="showSuggestion">
      <div class="dialog-mask" @click="showSuggestion = false"></div>
      <div class="suggestion-panel">
        <div class="panel-header">
          <span class="panel-title">我给小慧提建议</span>
          <span class="panel-close" @click="showSuggestion = false">关闭</span>
        </div>
        <div class="suggestion-body">
          <textarea class="suggestion-input" v-model="suggestionText" placeholder="请输入您的建议..."></textarea>
        </div>
        <div class="suggestion-footer">
          <button class="btn-cancel" @click="showSuggestion = false">取消</button>
          <button class="btn-submit" @click="submitSuggestion">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Xiaohui',
  data() {
    return {
      inputValue: '',
      currentRegion: '省本级',
      showRegionPicker: false,
      showSuggestion: false,
      suggestionText: '',
      messages: [
        { text: '您好，欢迎来到江苏省人社一体化信息平台，我是您的专属智能助手，请问有什么可以帮您？', isUser: false }
      ],
      regions: ['江苏省', '南京市', '无锡市', '徐州市', '常州市', '苏州市'],
      imgs: {
        logo: require('@/assets/icons/xh-logo-banner.png'),
        avatar: require('@/assets/icons/xh-avatar.png'),
        badge: require('@/assets/icons/xh-badge.png'),
        findError: require('@/assets/icons/xh-find-error.png'),
        userAvatar: require('@/assets/icons/xh-user-avatar.png')
      }
    }
  },
  methods: {
    sendMessage() {
      if (!this.inputValue.trim()) return
      
      // 用户消息
      this.messages.push({ text: this.inputValue, isUser: true })
      this.inputValue = ''
      
      // 小慧回复
      setTimeout(() => {
        this.messages.push({ text: '换个问法试试吧，如果还不能回答我就需要更加努力学习了。', isUser: false })
        this.messages.push({ text: '您可能还关注与此相关的其他问题：', isUser: false, isTip: true })
        this.messages.push({ text: '转人工', isUser: false, isAction: true })
        this.scrollToBottom()
      }, 500)
      
      this.scrollToBottom()
    },
    selectRegion(region) {
      this.currentRegion = region
      this.showRegionPicker = false
    },
    submitSuggestion() {
      if (!this.suggestionText.trim()) return
      this.showSuggestion = false
      this.suggestionText = ''
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const area = this.$refs.chatArea
        if (area) area.scrollTop = area.scrollHeight
      })
    }
  }
}
</script>

<style scoped>
.xiaohui {
  background: #f9f9f9;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
/* 顶部标题栏 */
.header {
  background: #fff;
  text-align: center;
  padding: calc(38 * var(--w)) 0 calc(34 * var(--w));
}
.title {
  font-size: calc(46 * var(--w));
  font-weight: bold;
  color: #333;
}
/* 顶部横幅 */
.banner {
  display: flex;
  align-items: center;
  padding: calc(30 * var(--w)) calc(64 * var(--w));
  /* background: linear-gradient(90deg, #2fa0da, #1b93cd); */
 background-color: #2DA4DB;
}
.banner-logo {
  width: calc(110 * var(--w));
  height: calc(110 * var(--w));
  flex-shrink: 0;
  object-fit: contain;
}
.banner-text {
  color: #fff;
  /* 缩小与 logo 图标之间的间距 */
  margin-left: calc(24 * var(--w));
}
.banner-line1 {
  font-size: calc(36 * var(--w));
  margin-bottom: calc(10 * var(--w));
}
.banner-line2 {
  font-size: calc(50 * var(--w));
  font-weight: bold;
  display: flex;
  align-items: center;
}
.banner-divider {
  display: inline-block;
  width: calc(4 * var(--w));
  height: calc(44 * var(--w));
  background: rgba(255, 255, 255, 0.7);
  margin: 0 calc(40 * var(--w)) 0 calc(50 * var(--w));
}
.banner-assistant {
  font-size: calc(44 * var(--w));
  font-weight: normal;
}
/* 聊天区域 */
.chat-area {
  flex: 1;
  padding: calc(120 * var(--w)) calc(35 * var(--w)) calc(60 * var(--w));
  overflow-y: auto;
}
.message-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: calc(40 * var(--w));
}
.message-item.user-msg {
  flex-direction: row-reverse;
}
.avatar {
  width: calc(145 * var(--w));
  height: calc(145 * var(--w));
  /* 头像只显示圆形 */
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
  object-fit: cover;
}
.bubble {
  position: relative;
  background: #fff;
  border-radius: calc(20 * var(--w));
  padding: calc(40 * var(--w)) calc(46 * var(--w));
  font-size: calc(44 * var(--w));
  color: #333;
  line-height: 1.6;
  /* 无上边距：气泡文字顶部与头像顶部平齐 */
  margin-left: calc(50 * var(--w));
  max-width: calc(790 * var(--w));
}
.bubble::before {
  content: '';
  position: absolute;
  left: calc(-14 * var(--w));
  top: calc(50 * var(--w));
  border-top: calc(16 * var(--w)) solid transparent;
  border-bottom: calc(16 * var(--w)) solid transparent;
  border-right: calc(16 * var(--w)) solid #fff;
}
.bubble.user-bubble {
  background: #95ec69;
  margin-left: 0;
  margin-right: calc(50 * var(--w));
}
.bubble.user-bubble::before {
  left: auto;
  right: calc(-14 * var(--w));
  border-right: none;
  border-left: calc(16 * var(--w)) solid #95ec69;
}
/* 底部区域 */
.footer {
  background: #f9f9f9;
}
.location-bar {
  display: flex;
  align-items: center;
  padding: calc(20 * var(--w)) calc(36 * var(--w)) calc(24 * var(--w));
  font-size: calc(40 * var(--w));
  color: #333;
}
.highlight {
  color: #e02020;
  font-weight: bold;
}
.switch-btn {
  color: #2e8af0;
  display: flex;
  align-items: center;
  gap: calc(12 * var(--w));
  margin-left: calc(36 * var(--w));
  cursor: pointer;
}
.switch-icon {
  width: calc(48 * var(--w));
  height: calc(48 * var(--w));
}
.suggest-btn {
  color: #2e8af0;
  margin-left: calc(112 * var(--w));
  cursor: pointer;
}
.input-bar {
  display: flex;
  align-items: center;
  gap: calc(18 * var(--w));
  /* 左右边距一致（36w） */
  padding: calc(10 * var(--w)) calc(36 * var(--w)) calc(40 * var(--w)) calc(36 * var(--w));
}
.input-field {
  flex: 1;
  height: calc(116 * var(--w));
  background: #f1f1f1;
  border: none;
  border-radius: calc(16 * var(--w));
  padding: 0 calc(24 * var(--w));
  font-size: calc(40 * var(--w));
  outline: none;
}
.send-btn {
  width: calc(120 * var(--w));
  height: calc(116 * var(--w));
  background: #58c254;
  color: #fff;
  border: none;
  border-radius: calc(16 * var(--w));
  font-size: calc(44 * var(--w));
  padding: 0;
  flex-shrink: 0;
  cursor: pointer;
}
/* 底部信息区 */
.footer-info {
  display: flex;
  background: #f5f8fd;
  padding: calc(36 * var(--w)) calc(40 * var(--w)) calc(50 * var(--w)) calc(35 * var(--w));
}
.footer-left {
  width: calc(320 * var(--w));
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.badge-img {
  width: calc(145 * var(--w));
  margin-left: calc(43 * var(--w));
}
.find-error-img {
  width: calc(310 * var(--w));
  margin-top: calc(36 * var(--w));
}
.contact-info {
  flex: 1;
  margin-left: calc(70 * var(--w));
  font-size: calc(40 * var(--w));
  color: #333;
  line-height: calc(65 * var(--w));
}
.contact-title {
  color: #2e8af0;
}
/* 弹窗样式 */
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}
/* 省市区选择弹窗 */
.region-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.region-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: calc(16 * var(--w)) calc(16 * var(--w)) 0 0;
  z-index: 101;
}
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(24 * var(--w)) calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
}
.panel-title {
  font-size: calc(32 * var(--w));
  color: #333;
  font-weight: 500;
}
.panel-close {
  font-size: calc(28 * var(--w));
  color: #969799;
  cursor: pointer;
}
.region-list {
  max-height: calc(600 * var(--w));
  overflow-y: auto;
}
.region-item {
  padding: calc(24 * var(--w)) calc(32 * var(--w));
  font-size: calc(32 * var(--w));
  color: #333;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.region-item.active {
  color: #2e8af0;
}
/* 建议弹窗 */
.suggestion-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.suggestion-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: calc(16 * var(--w)) calc(16 * var(--w)) 0 0;
  z-index: 101;
}
.suggestion-body {
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.suggestion-input {
  width: 100%;
  height: calc(300 * var(--w));
  border: 1px solid #e5e5e5;
  border-radius: calc(8 * var(--w));
  padding: calc(16 * var(--w));
  font-size: calc(32 * var(--w));
  outline: none;
  resize: none;
}
.suggestion-footer {
  display: flex;
  border-top: 1px solid #f0f0f0;
}
.btn-cancel, .btn-submit {
  flex: 1;
  height: calc(88 * var(--w));
  border: none;
  font-size: calc(32 * var(--w));
  cursor: pointer;
}
.btn-cancel {
  background: #fff;
  color: #969799;
  border-right: 1px solid #f0f0f0;
}
.btn-submit {
  background: #fff;
  color: #2e8af0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Xiaohui.vue